<template>
  <el-dialog
    title="待复制信息"
    :visible.sync="dialogFormVisible"
    width="600px"
    class="copy-order-info"
  >
    <div class="item">
      <div class="label">产品名称：</div>
      <div class="value">
        {{ project_name }} {{ service_duration }}分钟
        {{ trip_type === 1 ? '拼团' : trip_type === 2 ? '包团' : '' }}
        {{ interval_time }}
      </div>
    </div>
    <div class="item">
      <div class="label">出行日期：</div>
      <div class="value">{{ use_date }}</div>
    </div>
    <div v-for="(item, index) in ordersOne" :key="index">
      <div class="item">
        <div class="label">联系人：</div>
        <div class="value">
          {{ item.contact.name }} / {{ item.user_num }}人 / {{ item.contact.mobile }}
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <h4 v-if="orders.length > 0">新增订单</h4>
    <div v-for="(item, index) in orders" :key="index">
      <div class="item">
        <div class="label">联系人：</div>
        <div class="value">
          {{ item.contact.name }} / {{ item.user_num }}人 / {{ item.contact.mobile }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getAssignDetail } from '@/api/batchOrder'
export default {
  name: 'CopyOrderInfo',
  data() {
    return {
      dialogFormVisible: false,
      ordersOne: [],
      orders: [],
      project_name: '',
      use_date: '',
      service_duration: 0,
      trip_type: 0,
      interval_time: ''
    }
  },
  created() {},
  methods: {
    handleCopyInfo(guide_service_id) {
      getAssignDetail({
        guide_service_id
      }).then((res) => {
        const { project_name, orders, use_date, service_duration, trip_type, interval_time } =
          res.data
        this.ordersOne = orders.filter((item) => item.is_first_assign)

        this.orders = orders.filter((item) => !item.is_first_assign)
        this.project_name = project_name
        this.use_date = use_date
        this.service_duration = service_duration
        this.trip_type = trip_type
        this.interval_time = interval_time
        this.dialogFormVisible = true
      })
    }
  }
}
</script>
<style scoped lang="less">
.copy-order-info {
  /deep/.el-dialog__body {
    padding: 12px 20px;
  }
  .item {
    display: flex;
    align-items: center;
    height: 30px;
    .label {
      width: 80px;
      color: #606266;
    }
    .value {
      color: #333;
    }
  }
  .el-divider--horizontal {
    margin: 12px 0;
  }
}
</style>
